export const templatesList = [
  // Original 12 Pokémon-named templates
  "azurill",
  "bronzor",
  "chikorita",
  "ditto",
  "gengar",
  "glalie",
  "kakuna",
  "leafish",
  "nosepass",
  "onyx",
  "pikachu",
  "rhyhorn",
  // 016-design-refresh: 6 new templates
  "editorial",
  "swiss",
  "console",
  "signal",
  "arc",
  "europass-plus",
] as const;

export type Template = (typeof templatesList)[number];

/**
 * Templates gated to paid tiers (Pro + Ultimate). Free users see them in the
 * picker with a lock badge and cannot select them. Enforced both client-side
 * (lock UI) and server-side (resume update rejects mismatched tier).
 */
export const PRO_TEMPLATES: ReadonlySet<Template> = new Set<Template>([
  "editorial",
  "swiss",
  "console",
  "signal",
  "arc",
  "europass-plus",
]);

export const isProTemplate = (template: string | null | undefined): boolean =>
  template != null && PRO_TEMPLATES.has(template as Template);
